// extracted by mini-css-extract-plugin
export default {"badge":"nIF7N6QYeB1mPsFFX50d","badge-critical":"ewwNcVDaCRITB3yUZyRM","badge-high":"KNadGiDysB0mJG7IaGZT","badge-medium":"Jx5_fKAe7kjA7y8SJXDB","badge-low":"dE6WZ5LcrLVS2mZH4ee5"};